import React, { Component } from "react";
import { Modal, message, Image } from "antd";

class showImages extends Component {
  state = {
    loading: true,
    station: [],
    selectedStationId: "",
    input: ""
  };

  async componentDidMount() {
    try {
      const { cargoBooking } = this.props;
      if (cargoBooking) {
        this.setState({ bookingImagePath: cargoBooking, loading: false });
      } else {
        this.setState({ loading: false });
      }
    } catch (err) {
      message.error(err);
    }
  }

  render() {
    const { loading, bookingImagePath } = this.state;
    const { onChange } = this.props;
    const name = `Loaded Image`;

    return (
      <Modal
        title={name}
        visible={true}
        onCancel={() =>
          onChange({ showImages: false, bookingToEdit: {}, editField: "" })
        }
        footer={null}
      >
        {loading ? (
          "...Loading"
        ) : bookingImagePath ? (
          <div>
            <Image
              src={"https://d370edwo3kkakj.cloudfront.net/" + bookingImagePath}
            />
          </div>
        ) : (
          "NO IMAGE FOUND"
        )}
      </Modal>
    );
  }
}

export default showImages;
